import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const CreateWhatsAppTemplate = lazy(() =>
  import("@scenes/MessageComposition/WhatsApp/WhatsAppTemplateLibrary").then((module) => ({
    default: module.CreateWhatsAppTemplate,
  }))
);

export const WhatsAppTemplatesCreateNRO: NavigationRoutingObject = {
  section: "templates",
  Component: CreateWhatsAppTemplate,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("whats-app-templates-create-nro-heading", "Create WhatsApp Templates"),
  tag: "new",
  getDeveloperNavigationAllowed: ({ featureOn, hasPermission }) => {
    return (
      featureOn("whats_app_template_builder") &&
      hasPermission("appGroup", { permission: "editWhatsappMessageTemplates" })
    );
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
};
